import App from './App';

export { App };



// WEBPACK FOOTER //
// ./src/comparison-new/containers/index.js